<div class="d-inline-block w-100">
  <div class="d-flex justify-content-between align-items-center gap-2">
    <ul class="grid-line-height list-unstyled m-0 py-1">
      @for (shareholder of holders; track shareholder.relationshipId) {
        <li class="shareholder line-height-16 font-size-12">
          <i
            class="icon ic-asic-black-white-20 mr-2 cursor-default"
            tooltipClass="tooltip-info"
            placement="top"
            container="body"
            [ngbTooltip]="nonAsic ? 'non-ASIC' : 'ASIC'"
            [class]="{
              'bg-gray-600': nonAsic,
              'bg-asic-blue': !nonAsic
            }"
          ></i>

          <i
            class="icon mr-2"
            [class]="{
              'ic-companies-16': shareholder.$type === 'CorporateHolderModel',
              'ic-my-account-16': shareholder.$type === 'IndividualHolderModel'
            }"
          ></i>

          <span>{{ shareholder.name }}</span>
        </li>
      }
    </ul>

    @if ((hasIssue || hasWarning) && hasWarning) {
      <div
        class="warning-icon"
        container="body"
        placement="top"
        tooltipClass="tooltip-info"
        [ngbTooltip]="issueMessage"
      >
        <i class="icon ic-alert-triangle-16"></i>
      </div>
    }
  </div>

</div>
